import React from "react";
import { Link } from "react-router-dom";
import { apiUrl } from "../../config/config";

const BlogCard = ({ blog }) => {
  return (
    <div className="bg-white rounded-lg shadow hover:shadow-xl transition overflow-hidden">
      
      {blog.image && (
        <img
          src={`${apiUrl}/storage/${blog.image}`}
          alt={blog.title}
          className="w-full h-48 object-cover"
        />
      )}

      <div className="p-4">
        <h3 className="text-lg font-semibold mb-2 line-clamp-2">
          {blog.title}
        </h3>

        <p className="text-sm text-gray-500 mb-3">
          Category: {blog.category?.name || "N/A"}
        </p>

        <Link
          to={`/blogs/${blog.slug}`}
          className="text-blue-600 hover:underline font-medium"
        >
          Read More →
        </Link>
      </div>
    </div>
  );
};

export default BlogCard;
